import { API_BASE_URL } from "../config/apiBase";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const fetchAdminBookingsList = async () => {
  const res = await fetch(`${API_BASE_URL}/bookings/admin/list`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok || !data.status) {
    throw new Error(data.message || "Failed to load bookings");
  }
  return data.result || [];
};

export const fetchAdminBookingDetail = async (bookingId) => {
  const res = await fetch(`${API_BASE_URL}/bookings/admin/detail/${bookingId}`, {
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok || !data.status) {
    throw new Error(data.message || "Failed to load booking");
  }
  return data.result;
};

export const adminReleasePayout = async (bookingId) => {
  const res = await fetch(
    `${API_BASE_URL}/bookings/admin/${bookingId}/release-payout`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({}),
    }
  );
  const data = await res.json();
  if (!res.ok || !data.status) {
    throw new Error(data.message || "Payout release failed");
  }
  return data;
};

/** Filter bookings by admin tab key */
export const filterBookingsByTab = (rows, tab) => {
  if (!Array.isArray(rows)) return [];
  switch (tab) {
    case "pending":
      return rows.filter((b) => b.lifecycleKey === "pending");
    case "active":
      return rows.filter((b) => b.lifecycleKey === "active");
    case "completed":
      return rows.filter((b) => b.lifecycleKey === "completed");
    case "canceled":
      return rows.filter((b) => b.lifecycleKey === "canceled");
    default:
      return rows;
  }
};

export const computeBookingStats = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  return {
    total: list.length,
    pending: list.filter((b) => b.lifecycleKey === "pending").length,
    active: list.filter((b) => b.lifecycleKey === "active").length,
    completed: list.filter((b) => b.lifecycleKey === "completed").length,
    canceled: list.filter((b) => b.lifecycleKey === "canceled").length,
    refunded: list.filter(
      (b) => String(b.paymentStatus || "").toLowerCase() === "refunded"
    ).length,
  };
};
